import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Link } from 'react-router';
import { resetPassword } from '../../actions/authentication/passwordCreators';
import { Grid, Row, Col, Alert } from 'react-bootstrap';
import { Helmet } from 'react-helmet';
import Header from '../../components/Header';
import Banner from '../../components/Banner';
import PasswordForm from './PasswordForm';

class ResetPassword extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      token: undefined,
      isSaving: false
    };
  }

  componentDidMount() {
    const token = this.props.location.query.token;
    if (token) {
      this.setState({ token });
    }
  }

  resetPassword = values => {
    this.setState({ message: undefined });

    const token = this.state.token;
    const newPassword = values.newPassword;
    this.props.resetPassword(newPassword, token).then(
      success => {
        this.setState({
          message: 'Password successfully updated.',
          messageType: 'success'
        });

        this.props.router.push('/');
      },
      error =>
        this.setState({
          message: error.data.message,
          messageType: 'danger'
        })
    );
  };

  render() {
    return (
      <div className="App" aria-live="polite">
        <Helmet>
          <title>Reset Password | Campaign Targeter</title>
        </Helmet>
        <Header />
        <Banner title="Set a new password" image="mailbox" />
        <Grid>
          <Row>
            <Col sm={8} smOffset={2} md={8} mdOffset={3} lg={6} lgOffset={3}>
              <br />
              <br />
              {this.state.token && (
                <div>
                  <p>Set a new password for your account.</p>
                  <PasswordForm
                    onSubmit={this.resetPassword}
                    initialValues={{}}
                    isArchiving={this.state.isArchiving}
                    message={this.state.message}
                    messageType={this.state.messageType}
                    isSaving={this.state.isSaving}
                    enableReinitialize
                    hideCurrent
                  />
                </div>
              )}

              {!this.state.token && (
                <Alert bsStyle="danger">
                  <p>Token is not valid.</p>
                  <p>
                    Please click on the link from the email, or{' '}
                    <Link to="/forgot-password">
                      reset your password again.
                    </Link>
                  </p>
                </Alert>
              )}
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      resetPassword
    },
    dispatch
  );
}

export default connect(undefined, mapDispatchToProps)(ResetPassword);



// WEBPACK FOOTER //
// ./src/containers/account/ResetPassword.js